import React from "react";
import { useTranslation } from "react-i18next";

export const MediaItem = ({ title, publicURL, ...rest }) => (
  <div className="media-link-item mb-4 mx-3 mx-xl-5" {...rest}>
    <img
      src={publicURL}
      className={`img-grayscale`}
      alt={title}
      height={30}
      loading="eager"
    />
  </div>
);

const TrustedMediaList = ({ links }) => {
  const { t } = useTranslation();
  return (
    <div id="media-links" className="container d-flex flex-column py-5 mt-4">
      <div className="d-flex flex-row flex-wrap flex-lg-nowrap justify-content-center">
        {links?.edges.map(({ node: { title, acfMediaLinks } }, i) => (
          <MediaItem
            key={`medie-item-${i}`}
            title={title}
            publicURL={acfMediaLinks.mlMediaLogoColoured.localFile.publicURL}
          />
        ))}
      </div>
      <p className="grid-col-12  has-text-align-center mt-5">
        <span className="has-inline-color has-cyan-bluish-gray-color">
          {t("common.trustedBy")}
        </span>
      </p>
    </div>
  );
};

export default TrustedMediaList;
